// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"31d6cfe0","154":"31d6cfe0","189":"e6de7b9c","461":"7de101c2","489":"31d6cfe0","637":"071882e4","965":"31d6cfe0"}[chunkId] + ".chunk.css";
};